module.exports = __webpack_public_path__ + "static/img/products discription_redmud2.777ce4f9.jpg";